export const formatRefreshCountdown = (
  secondsRemaining: number,
  condensed: boolean
): string => {
  if (secondsRemaining <= 0) {
    return condensed ? 'now' : 'Inbox refreshing…';
  }

  const shortLabel: string =
    secondsRemaining < 60
      ? `${secondsRemaining}s`
      : `${Math.ceil(secondsRemaining / 60)}m`;

  if (condensed) {
    return shortLabel;
  }

  return `Inbox refreshes in ${shortLabel}`;
};